import { Link } from 'react-router-dom';
import { FaXTwitter, FaTelegram, FaInstagram, FaWhatsapp, FaFacebook } from 'react-icons/fa6';
import Logo from '../common/Logo';
import { TELEGRAM_CHANNEL_URL } from '../../config/social';
import './Footer.css';

function Footer() {
  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/people/Jobs-Opportuniti/pfbid0vDPT2QsHfzUS26Q94JgptsuioacViMEiDH3JKFBVgiv27SxnjSsthk7r63EZNXw9l/',
      icon: <FaFacebook />
    },
    { 
      name: 'Instagram', 
      url: 'https://www.instagram.com/jobsopportunity.in/?igsh=NDI4N2p3ZW1yM24%3D#', 
      icon: <FaInstagram /> 
    },
    { 
      name: 'X (Twitter)', 
      url: 'https://x.com/Jobsopport61352?t=B5pSngdXa5VdKvp7HvXDtQ&s=08', 
      icon: <FaXTwitter /> 
    },
    { 
      name: 'Telegram', 
      url: TELEGRAM_CHANNEL_URL, 
      icon: <FaTelegram /> 
    },
    { 
      name: 'WhatsApp', 
      url: 'https://wa.me/919380867233', 
      icon: <FaWhatsapp /> 
    }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Logo and About Section */}
          <div className="footer-section brand-section">
            <Logo isStatic={true} className="footer-logo" />
            <p className="footer-slogan">One Click To Your Career. Find Your Fit</p>
            <p className="footer-description">
              An informational job-sharing platform connecting talented individuals with career opportunities.
            </p>
          </div>
          
          {/* Quick Links Section */}
          <div className="footer-section">
            <h3>Quick Links</h3>
            <div className="footer-links">
              <Link to="/">Home</Link>
              <Link to="/about">About Us</Link>
              <Link to="/blogs">Blogs</Link>
              <Link to="/search">Jobs</Link>
              <Link to="/disclaimer">Disclaimer</Link>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/cookie-policy">Cookie Policy</Link>
            </div>
          </div>
          
          {/* Connect With Us Section */}
          <div className="footer-section">
            <h3>Connect With Us</h3>
            <div className="social-links">
              {socialLinks.map(link => (
                <a 
                  key={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  {link.icon}
                  <span className="social-name">{link.name}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} JobsOpportunity. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 